module.exports = __webpack_public_path__ + "assets/img/0-12.67b977cc.svg";